<div class="flex flex-col h-full justify-between">
  <ul class="space-y-8">
        <li
          class='border-0'
          routerLink="/dashboard"
          routerLinkActive="text-yellow-500  font-semibold"
        >
          <a class="flex items-center">
            <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fa fa-dashboard text-base"></span>
            <span class="ml-4 text-base">Monitor</span>
          </a>
        </li>

    <li
      class='border-0'
      routerLink="/operations"
      routerLinkActive="text-yellow-500  font-semibold"
    >
      <a class="flex items-center">
        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-activity text-base"></span>
        <span class="ml-4 text-base">Operations</span>
      </a>
    </li>

    <li
      class='border-0'
      routerLink="/drivers"
      routerLinkActive="text-yellow-500  font-semibold"
    >
      <a class="flex items-center">
        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-user-check text-base"></span>
        <span class="ml-4 text-base">Drivers</span>
      </a>
    </li>

    <li
      class='border-0'
      routerLink="/buses"
      routerLinkActive="text-yellow-500  font-semibold"
    >
      <a class="flex items-center">
        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fa fa-bus text-base"></span>
        <span class="ml-4 text-base">Buses</span>
      </a>
    </li>

    <li
      class='border-0'
      routerLink="/terminals"
      routerLinkActive="text-yellow-500  font-semibold"
    >
      <a class="flex items-center">
        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fa fa-building-o text-base"></span>
        <span class="ml-4 text-base">Terminals</span>
      </a>
    </li>

    <li
      class='border-0'
      routerLink="/access-control"
      routerLinkActive="text-yellow-500  font-semibold"
    >
      <a class="flex items-center">
        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-shield text-base"></span>
        <span class="ml-4 text-base">Access Control</span>
      </a>
    </li>


<!--    <li-->
<!--      class='border-0'-->
<!--      routerLink="/transactions"-->
<!--      routerLinkActive="text-yellow-500  font-semibold"-->
<!--    >-->
<!--      <a class="flex items-center">-->
<!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-trending-up text-base"></span>-->
<!--        <span class="ml-4 text-base">Transactions</span>-->
<!--      </a>-->
<!--    </li>-->

<!--    -->

<!--    <li-->
<!--      class='border-0'-->
<!--      routerLink="/merchants"-->
<!--      routerLinkActive="text-yellow-500  font-semibold"-->
<!--    >-->
<!--      <a class="flex items-center">-->
<!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-user-check text-base"></span>-->
<!--        <span class="ml-4 text-base">Conductors</span>-->
<!--      </a>-->
<!--    </li>-->

    <!--    <li-->
    <!--      routerLink="/members"-->
    <!--      routerLinkActive="text-yellow-500 font-semibold"-->
    <!--    >-->
    <!--      <a class="flex items-center">-->
    <!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-user-check text-base"></span>-->

    <!--        <span class="ml-4 text-base">Members</span>-->
    <!--      </a>-->
    <!--    </li>-->

<!--    <li-->
<!--      routerLink="/members"-->
<!--      routerLinkActive="text-yellow-500 font-semibold"-->
<!--    >-->
<!--      <a class="flex items-center">-->
<!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-credit-card text-base"></span>-->

<!--        <span class="ml-4 text-base">Card Holders</span>-->
<!--      </a>-->
<!--    </li>-->

    <!--    <li-->
    <!--      routerLink="/bulk-sms"-->
    <!--      routerLinkActive="text-yellow-500 font-semibold"-->
    <!--    >-->
    <!--      <a class="flex items-center">-->
    <!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-send text-base"></span>-->

    <!--        <span class="ml-4 text-base">Bulk SMS</span>-->
    <!--      </a>-->
    <!--    </li>-->

    <!--    <li-->
    <!--      routerLink="/users"-->
    <!--      routerLinkActive="text-yellow-500 font-semibold"-->
    <!--    >-->
    <!--      <a class="flex items-center">-->
    <!--        <span class="inline-block font-semibold ml-2 w-6 h-6 text-yellow-500 stroke-0 fe fe-users text-base"></span>-->

    <!--        <span class="ml-4 text-base">Users</span>-->
    <!--      </a>-->
    <!--    </li>-->
  </ul>

  <div class=''>
    <div *ngIf='authUser$|async as auth' class='flex items-center'>
      <ngx-avatars [name]='auth.name'></ngx-avatars>
      <div class='ml-2'>
        <div class='text-md font-semibold'>{{auth.name}}</div>
        <div class='text-sm'>{{auth.role}}</div>
      </div>
    </div>
    <div class='mt-4'>
      <a (click)='logout()' nz-button nzBlock nzDanger nzType='default'>Logout</a>
    </div>
  </div>
</div>
